export default class WorkPlanReviewPhaseApprobationCtrl {
  constructor ($scope, $timeout, $stateParams, WorkPlanSrv, $cookies, $rootScope, $interval) {
    const reviewPhaseApprobationVm = this;
        
    $rootScope.fullscreenClass = 'background-planning'

    // Grid definition    
    reviewPhaseApprobationVm.gridOptions = {
      columnDefs: [
        {
          displayName: 'Nombre profesor',
          name: 'Nombre profesor',
          field: 'ds_name',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          displayName: 'Plan de trabajo asignado',
          name: 'Plan de trabajo asignado',
          field: 'workplan_name',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          displayName: 'Estado',
          name: 'Estado',
          field: 'state_name',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: true,
        }, {
          displayName: 'Acciones',
          name: 'Acciones',
          field: 'id_state',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: require('./cellTemplateWorkPlanReviewPhaseApprobationActions.html')
        }
      ],
      onRegisterApi: (gridApi) => {
        reviewPhaseApprobationVm.gridApi = gridApi
        reviewPhaseApprobationVm.gridApi.grid.registerRowsProcessor(reviewPhaseApprobationVm.singleFilter, 200)
        $interval(function () {
          reviewPhaseApprobationVm.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }

    // VARIABLES
    reviewPhaseApprobationVm.workPlanFilter = ''

    // METHODS
    reviewPhaseApprobationVm.singleFilter = singleFilter
    reviewPhaseApprobationVm.filter = filter    

    
    function filter () {
      reviewPhaseApprobationVm.gridApi.grid.refresh()
    }

    function singleFilter (renderableRows) {
      var matcher = new RegExp(reviewPhaseApprobationVm.workPlanFilter,'i')
      renderableRows.forEach(function (row) {
        var match = false;
        [ 'ds_name', 'workplan_name', 'state_name', 'id_state' ].forEach(function (field) {
          if (row.entity[field].match(matcher)) {
            match = true
          }
        })
        if (!match) {
          row.visible = false
        }
      })
      return renderableRows
    }

   activate ()

    function activate(){
        getListItemsTest()
    }

    function getListItems () {
        let params = {
            id_user: user = JSON.parse($cookies.get('currentUser')),
            is_review: 2,
            is_rejected: null
        }
        WorkPlanSrv.getWorkPlansInReview.get(params).$promise.then((dataReturn) => {
            if (dataReturn.status === true) {
            reviewPhaseApprobationVm.gridOptions.data = dataReturn.data
            } else {
            console.log(dataReturn)
            }
        }).catch((err) => {
            console.log('Error: ', err)
        })
    }

    function getListItemsTest () {
      reviewPhaseApprobationVm.gridOptions.data = [
      {ds_name:"Nombre profesor 1", workplan_name:"workplan 1", state_name:"estado 1", id_state:"1"},
      {ds_name:"Nombre profesor 2", workplan_name:"workplan 2", state_name:"estado 2", id_state:"2"}
    ];

    }

  }
}

WorkPlanReviewPhaseApprobationCtrl.$inject = ['$scope', '$timeout', '$stateParams', 'WorkPlanSrv', '$cookies', '$rootScope', '$interval']





// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/start/approbation/workplanReviewPhaseApprobationCtrl.js